angular.module('client-feature')
    .service('ClientFeatureService', function ($rootScope, modals, ClientFeature, ClientFeatureConst) {
        this.edit = entity => {
            return modals.open('app/client-feature/edit-modal.html', 'ClientFeatureDialogController', angular.copy(entity), {size: 'md'}, "$ctrl")
        }
        this.add = () => {
            let entity = {
                active: true,
                id: null
            }
            return this.edit(entity)
        }
        this.remove = item => {
            return modals.confirmDelete(item.name, () => ClientFeature.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast(ClientFeatureConst.eventUpdate)))
        }
    })
